import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

//insomnia
import { Insomnia } from '@ionic-native/insomnia/';

/**
 * Generated class for the DetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-details',
  templateUrl: 'details.html',
})
export class DetailsPage {

  itemTitle: string;
  itemContent: string
  itemLink: string
  itemDuration: string
  itemHost: string
  itemSize: number

  constructor(public navCtrl: NavController, public navParams: NavParams, private insomnia: Insomnia) {

    this.itemTitle = navParams.get('itemTitle');
    this.itemContent = navParams.get('itemContent');
    this.itemLink = navParams.get('itemLink');
    this.itemDuration = navParams.get('itemDuration');
    this.itemHost = navParams.get('itemHost');
    this.itemSize = navParams.get('itemSize');
    this.itemSize = this.itemSize *0.000001;

    console.log ("itemLink = " + this.itemLink);
    console.log ("itemTitle = "+this.itemTitle);
    console.log ("itemHost = "+this.itemHost);
    console.log ("itemDuration = "+this.itemDuration);
    console.log ("itemContent = "+this.itemContent);
    console.log ("itemSize = " +this.itemSize);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DetailsPage. Now screen staying awake!');
    window['plugins'].insomnia.keepAwake()
  }

  ionViewWillLeave() {
    this.insomnia.allowSleepAgain();
  }

}



// WEBPACK FOOTER //
// ./src/pages/details/details.ts